/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enabledproblemreports2Inputs */

const en__field_enabledproblemreports2 = /** @type {(inputs: _Field_Enabledproblemreports2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled problem reports`)
};

/**
* | output |
* | --- |
* | "Enabled problem reports" |
*
* @param {_Field_Enabledproblemreports2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_enabledproblemreports2 = /** @type {((inputs?: _Field_Enabledproblemreports2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enabledproblemreports2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_enabledproblemreports2(inputs)
});
export { _field_enabledproblemreports2 as "_field_enabledProblemReports" }